var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "circles",
    width: 672,
    height: 656,
    viewBox: "0 0 672 656",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_283_14563",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 672,
    height: 656
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 672,
    height: 656,
    fill: "url(#paint0_radial_283_14563)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_283_14563)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 672,
    height: 578.651,
    transform: "translate(0 -10.979)",
    fill: "url(#paint1_radial_283_14563)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 336,
    cy: 256.548,
    r: 47.5,
    stroke: "#B1D4F6"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 336,
    cy: 256.548,
    r: 95.5,
    stroke: "#B1D4F6"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 336,
    cy: 256.548,
    r: 143.5,
    stroke: "#B1D4F6"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 336,
    cy: 256.548,
    r: 191.5,
    stroke: "#B1D4F6"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 336,
    cy: 256.548,
    r: 239.5,
    stroke: "#B1D4F6"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 336,
    cy: 256.548,
    r: 287.5,
    stroke: "#B1D4F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_283_14563",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(336 262) rotate(90) scale(319 314.935)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_283_14563",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(336 289.325) rotate(90) scale(332.38 372.007)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles);
export default __webpack_public_path__ + "static/media/circles.6d35e3dd98fa9e12faa86b4126819c41.svg";
export { ForwardRef as ReactComponent };